import MultiquoteCoverage from './MultiquoteCoverage'

export default MultiquoteCoverage
